import gql from "graphql-tag";

export const CREATE_NOTE = gql`
  mutation ($input: createNoteInput) {
    createNote(input: $input) {
      title
    }
  }
`;
